import { api } from "../../api";
import { IAddAccountBitget } from "../../interfaces/BitgetAccount";
import { IAddAccountOkx } from "../../interfaces/OkxAccount";

export const postAddAccountBitget = async (data: IAddAccountBitget) => {
  const response = await api.post(`/integration/bitget/account`, data);
  return response;
};

export const postAddAccountOkx = async (data: IAddAccountOkx) => {
  const response = await api.post(`/web/okx/credentials`, data);
  return response;
};
